var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar2"},[_c('div',{staticClass:"green-bar"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }